import { toUpper, startCase, upperFirst } from 'lodash-es';
import moment from 'moment';
import { toFixed } from '@/pages/intelligence/utils/commonUtils';
import { getMetricNameTips } from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Summary/components/GamePerformanceSummary/utils';
import { METRICS_INFOS } from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Summary/components/GamePerformanceSummary/constants';
import { financeFormat } from '@/pages/home/utils/common';
import { RATIOVALUEFORMATOVERVIEWCARDMETRIC } from '@/pages/intelligence/components/OverviewCard/utils/const';

const activeUserCase = ['mau', 'wau', 'dau'];
const activeUserUpper = ['MAU', 'WAU', 'DAU'];
const pcu = ['pcu', 'rpd'];

// 当数据为空时，指标卡片显示
const indicatorPC = [
  {
    titleContent: 'MAU',
    titleIcon: 'newzoo',
  },
  {
    titleContent: 'PCU',
    titleIcon: 'steam',
  },
  {
    titleContent: 'Digital Revenue($)',
    titleIcon: 'mscience',
  },
  {
    titleContent: 'Physical Revenue($)',
    titleIcon: 'mscience',
  },
  {
    titleContent: 'Digital ARPPU($)',
    titleIcon: 'mscience',
  },
];
const indicatorConsole = [
  {
    titleContent: 'MAU',
    titleIcon: 'newzoo',
  },
  {
    titleContent: 'lifetime_player',
    titleIcon: 'newzoo',
  },
  {
    titleContent: 'Digital Revenue($)',
    titleIcon: 'mscience',
  },
  {
    titleContent: 'Physical Revenue($)',
    titleIcon: 'mscience',
  },
  {
    titleContent: 'Digital ARPPU($)',
    titleIcon: 'mscience',
  },
];

/**
 * @name: 处理卡片右上角日期格式
 * @param {*} date 要处理的日期
 * @param {*} conditionDate 需要处理日期格式的类型
 * @return {*}
 */
// export function indicatorsDateFormat(date: any, conditionDate = 'month') {
//   let _latestDate = '';
//   // 判断当前日期显示的格式
//   if (conditionDate == 'month' || conditionDate == 'Month') {
//     _latestDate = formatCalendar(date, '', 'Month');
//   } else if (conditionDate == 'day' || conditionDate == 'Day') {
//     _latestDate = formatCalendar(date, '', 'Day');
//   } else if (conditionDate == 'week' || conditionDate == 'Week') {
//     _latestDate = formatCalendar(date, '', 'Week');
//   }
//   return _latestDate;
// }

/**
 * @name: 指标排名变动处理
 * @param {*} dod
 * @return {
 *   _indicatorContent：数值内容；
 *   _indicatorSize：判断数值是正数，负数，零，或new；
 *    _indicatorColor：判断数值的颜色；
 *   _isIndicatorArrow：判断是否显示箭头；
 *   _indicatprsArrowColor：判断箭头的图标；
 * }
 */
export function indicatorValRankingFormat(dod: any) {
  // 指标值比例数据处理
  let _indicatorContent = '';
  let _indicatorSize = '';
  let _indicatorColor = '';
  let _isIndicatorArrow = false;
  let _indicatprsArrowColor = '';
  // 指标数据处理
  // 处理环比为0的情况
  if ([0, '0', '0.00', '0%', '-0%'].includes(dod)) {
    _indicatorContent = '0';
    _indicatorSize = 'zero';
    _indicatorColor = 'grayColor';
    _isIndicatorArrow = false;
    _indicatprsArrowColor = '';
  } else if (dod.includes('-')) {
    _indicatorContent = dod.slice(1);
    _indicatorSize = 'small';
    _indicatorColor = 'errorColor';
    _isIndicatorArrow = true;
    _indicatprsArrowColor = 'trendDown';
  } else {
    _indicatorContent = dod;
    _indicatorSize = 'big';
    _indicatorColor = 'successColor';
    _isIndicatorArrow = true;
    _indicatprsArrowColor = 'trendUp';
  }
  return {
    _indicatorContent,
    _indicatorSize,
    _indicatorColor,
    _isIndicatorArrow,
    _indicatprsArrowColor,
  };
}

/**
 * @name: 等级排名变动处理
 * @param {*} value_dod
 * @return {
 *   _rankContent:等级排名变动值；
 *   _rankColor:等级排名变动值颜色；
 *  _rankSize:等级排名的数值是正数，负数，零或new标识符；
 *  _isRankArrow:判断是否显示箭头；
 *  _rankArrowColor:判断箭头的图标；
 * }
 */
export function rankRankingFormat(value_dod: any) {
  // 等级排名比例数据处理
  let _rankContent = '';
  let _rankColor = '';
  let _rankSize = '';
  let _isRankArrow = false;
  let _rankArrowColor = '';
  // 等级排名比例数据处理
  if (value_dod == '') {
    _rankContent = '';
    _rankColor = 'grayColor';
    _rankSize = '';
    _isRankArrow = false;
    _rankArrowColor = 'trendUp';
  } else if (value_dod == '1000.00' || value_dod == '1000') {
    _rankContent = value_dod;
    _rankColor = 'grayColor';
    _rankSize = 'new';
    _isRankArrow = false;
    _rankArrowColor = 'grayUp';
  } else if (value_dod != '' && value_dod.includes('-')) {
    _rankContent = value_dod.slice(1);
    _rankColor = 'grayColor';
    _rankSize = 'small';
    _isRankArrow = true;
    _rankArrowColor = 'grayDown';
  } else {
    if (value_dod == 0.0 || value_dod == '0.00' || value_dod == 0) {
      _rankContent = '0';
      _isRankArrow = false;
    } else {
      _rankContent = value_dod.toString();
      _isRankArrow = true;
    }
    _rankColor = 'grayColor';
    _rankSize = 'big';
    _rankArrowColor = 'grayUp';
  }
  return {
    _rankContent,
    _rankColor,
    _rankSize,
    _isRankArrow,
    _rankArrowColor,
  };
}

const companySourceMetric = [
  {
    key: 'company_appannie_downloads',
    titleContent: 'Downloads',
  },
  {
    key: 'company_appannie_revenue',
    titleContent: 'Mobile Revenue($)',
  },
  {
    key: 'company_mscience_pc_revenue',
    titleContent: 'PC Digital Revenue($)',
  },
  {
    key: 'company_npd_pc_revenue',
    titleContent: 'PC Physical Revenue($)',
  },
  {
    key: 'company_mscience_console_revenue',
    titleContent: 'Console Digital Revenue($)',
  },
  {
    key: 'company_npd_console_revenue',
    titleContent: 'Console Physical Revenue($)',
  },
];

export const OverviewCardTitleMap = {
  'Ampere Mau': 'MAU',
  'Ampere Lifetime Users': 'Lifetime Player',
  'Ampere Avg Monthly Playtime': 'Avg Play Time(hrs)',
  'Ampere Dau': 'DAU',
  'Ampere D 1': 'D1',
  'Ampere D 7': 'D7',
} as any;

/**
 * @name: 指标卡片标题处理
 * @param {*}
 * @return {*}
 */
export function indicatorTitleContent(
  metric: string,
  data_source = '',
  conditionPlatform = '',
  intl?: any,
) {
  let _titleContent = '';

  // 公司卡片标题获取
  if (companySourceMetric?.findIndex((item: any) => item.key === metric) > -1) {
    const keyObj = companySourceMetric.find((item: any) => item.key === metric);
    return keyObj?.titleContent;
  }

  // 处理Databrain Revenue & Units平台的新指标
  if (conditionPlatform === 'Databrain Revenue & Units') {
    return intl?.formatMessage({ id: metric });
  }

  // Active Users类的指标全部大写
  if (activeUserCase.includes(metric) || pcu.includes(metric)) {
    _titleContent = toUpper(metric);
    // _titleContent = _.toUpper(metric);
  } else if (metric.includes(' ') || metric.includes('_')) {
    // 首字母命名
    _titleContent = startCase(metric);
    // _titleContent = _.startCase(metric);
  } else {
    // 其他-首字母大写
    _titleContent = upperFirst(metric);
    // _titleContent = _.upperFirst(metric);
  }
  if (data_source === 'famitsu rank' && metric === 'revenue') {
    _titleContent = 'Revenue of selected time';
  }
  if (_titleContent === 'DigitalARPPU') {
    _titleContent = 'Digital ARPPU($)';
  }
  if (_titleContent === 'DigitalRevenue') {
    _titleContent = 'Digital Revenue($)';
  }
  if (_titleContent === 'PhysicalRevenue') {
    _titleContent = 'Physical Revenue($)';
  }
  if (_titleContent === 'HoursWatched') {
    _titleContent = 'Hours Watched';
  }
  if (_titleContent === 'PeackCCV') {
    _titleContent = 'Peak CCV';
  }
  if (_titleContent === 'Retention D 2') {
    _titleContent = 'Retention D2';
  }
  if (_titleContent === 'Units') {
    _titleContent = 'Digital Units Sold';
  }
  if (_titleContent === 'SteamSales') {
    _titleContent = 'Units';
  }
  if (_titleContent === 'Revenue') {
    _titleContent = 'Revenue($)';
  }

  if (_titleContent === 'Sales') {
    _titleContent = 'Sales of selected time';
  }
  if (_titleContent === 'Cumulative Sales') {
    _titleContent = 'Cumulative Sales of the latest week';
  }
  if (_titleContent === 'Cumulative Revenue') {
    _titleContent = 'Cumulative Revenue of the latest week($)';
  }

  if (_titleContent === 'Gsd Digital Units') {
    _titleContent = 'Digital Units';
  }
  if (_titleContent === 'Gsd Physical Units') {
    _titleContent = 'Physical Units';
  }
  if (_titleContent === 'Pc Revenue') {
    _titleContent = 'PC Digital Revenue($)';
  }

  if (OverviewCardTitleMap[_titleContent]) {
    _titleContent = OverviewCardTitleMap[_titleContent];
  }
  // console.log('_titleContent', _titleContent);
  return _titleContent;
}

/**
 * @name: 处理卡片logo图标
 * @param {*} _titleContent：卡片标题
 * @param {*} type：logo处理类型，depContentTitle根据标题来确定logo，depPlatform根据平台来确定图标
 * @param {*} conditionPlatform：当type为depPlatform生效
 * @return {*}
 */
export function indicatorsTitleIcon(
  _titleContent: any,
  type: any,
  conditionPlatform: any,
  metric = '',
  dataSource = '',
) {
  const lifetimePlay = [
    'Lifetime Player',
    'lifetime_player',
    'Life Time Player',
  ];
  let _titleIcon = '';

  // 先按最优先级别来确定图标
  /**
   * Gamalytic 指标图标规则
   * - 后端在不同接口可能返回 `gamalytic_pcu` 或 `gamalytic__pcu`（单/双下划线）
   * - 产品期望：Gamalytic PCU/ACU 显示 Steam icon；其它 Gamalytic 指标显示 Gamalytic icon
   */
  const isGamalyticMetric = typeof metric === 'string' && metric.startsWith('gamalytic__');
  /**
   * source_steam 指标图标规则
   * - 后端 data_source='source_steam'，metric 形如 `source_steam__pcu` / `source_steam__acu`
   * - PCU/ACU 显示 Steam icon；其它 source_steam 指标也走 Steam
   */
  const isSourceSteamMetric = typeof metric === 'string' && metric.startsWith('source_steam__');
  /**
   * Alinea 指标图标规则
   * - 后端 data_source='alinea'，metric 形如 `alinea__est_units` / `alinea__est_revenue` / `alinea__pcu` 等
   * - 统一使用 Alinea icon，与 metricOptions 中各 alinea 列表 icon 配置保持一致
   */
  const isAlineaMetric =
    (typeof metric === 'string' && metric.startsWith('alinea__')) || dataSource === 'alinea';
  if (isGamalyticMetric) {
    const gamalyticMetricKey = metric.replace(/^gamalytic__/, '');
    if (['pcu', 'acu'].includes(gamalyticMetricKey)) {
      _titleIcon = 'steam';
    } else {
      _titleIcon = 'gamalytic';
    }
  } else if (isSourceSteamMetric) {
    _titleIcon = 'source_steam';
  } else if (isAlineaMetric) {
    _titleIcon = 'alinea';
  } else if (['est_revenue', 'est_units'].includes(metric)) {
    _titleIcon = 'vginsights';
  } else if (metric === 'gsd_digitalUnits' || metric === 'gsd_physicalUnits') {
    _titleIcon = 'gsd';
  } else if (
    _titleContent === 'Hours Watched' ||
    _titleContent === 'Peak CCV'
  ) {
    _titleIcon = 'hatchet';
  } else if (type === 'depDataSource') {
    _titleIcon = dataSource;
  } else if (type === 'depContentTitle') {
    // 根据title来确定图标
    if (['PCU', 'Steam PCU'].includes(_titleContent)) {
      _titleIcon = 'steam';
    } else if (
      activeUserUpper.includes(_titleContent) ||
      activeUserCase.includes(_titleContent) ||
      lifetimePlay.includes(_titleContent)
    ) {
      _titleIcon = 'newzoo';
    } else if (
      ['Digital ARPPU($)', 'Digital Revenue($)', 'Digital Units Sold'].includes(
        _titleContent,
      )
    ) {
      _titleIcon = 'mscience';
    } else if (_titleContent === 'Viewers') {
      _titleIcon = 'viewers';
    } else if (_titleContent === 'Physical Revenue($)') {
      _titleIcon = 'pnd';
    } else if (_titleContent === 'PHeat') {
      _titleIcon = 'databrain';
    } else if (
      [
        'Sales of selected time',
        'Revenue of selected time',
        'Cumulative Sales of the latest week',
        'Cumulative Revenue of the latest week($)',
        'Lifetime Total Revenue($)',
        'Lifetime Base Game Sales Units',
      ].includes(_titleContent)
    ) {
      _titleIcon = 'databrain';
    }
  } else if (type === 'depPlatform') {
    if (conditionPlatform === 'sensortower') {
      _titleIcon = 'sensortower';
    } else {
      _titleIcon = 'appnnie';
    }
  }
  return _titleIcon;
}

export const indicatorTitleContentForCombine = (metric: string): string => {
  let titleContentTmp = '';
  if (activeUserCase.includes(metric) || pcu.includes(metric)) {
    titleContentTmp = toUpper(metric);
  } else if (metric.includes(' ') || metric.includes('_')) {
    // 首字母命名
    titleContentTmp = startCase(metric);
  } else {
    // 其他-首字母大写
    titleContentTmp = upperFirst(metric);
  }

  const namesMap: {
    [key: string]: string;
  } = {
    PCU: 'Steam PCU',
    DigitalARPPU: 'Digital ARPPU($)',
    DigitalRevenue: 'Digital Revenue($)',
    PhysicalRevenue: 'Physical Revenue($)',
    HoursWatched: 'Hours Watched',
    PeackCCV: 'Peak CCV',
    'Est Revenue': 'Steam Revenue',
    'Est Units': 'Steam Units',
    'Retention D 2': 'Retention D2',
    Units: 'Digital Units',
    SteamSales: 'Units',
    Revenue: 'Revenue of the Latest Week',
    Sales: 'Sales of the Latest Week',
    'Cumulative Sales': 'Cumulative Sales of the Latest Week',
    'Cumulative Revenue': 'Cumulative Revenue of the Latest Week',
    'Gsd Digital Units': 'Digital Units',
    'Gsd Physical Units': 'Physical Units',
  };

  return namesMap[titleContentTmp] || titleContentTmp;
};

export const indicatorsTitleIconForCombine = (
  titleContentTmp: any,
  type: any,
  conditionPlatform: any,
  metric = '',
) => {
  const lifetimePlay = [
    'Lifetime Player',
    'lifetime_player',
    'Life Time Player',
  ];
  let titleIconTmp = '';
  // 先按最优先级别来确定图标
  if (['est_revenue', 'est_units'].includes(metric)) {
    titleIconTmp = 'vginsights';
  } else if (['gsd_digitalUnits', 'gsd_physicalUnits'].includes(metric)) {
    titleIconTmp = 'gsd';
  } else if (['Hours Watched', 'Peak CCV'].includes(titleContentTmp)) {
    titleIconTmp = 'hatchet';
  } else if (type === 'depContentTitle') {
    // 根据title来确定图标
    if (['PCU', 'Steam PCU'].includes(titleContentTmp)) {
      titleIconTmp = 'steam';
    } else if (
      activeUserUpper.includes(titleContentTmp) ||
      activeUserCase.includes(titleContentTmp) ||
      lifetimePlay.includes(titleContentTmp)
    ) {
      titleIconTmp = 'newzoo';
    } else if (
      [
        'Digital ARPPU($)',
        'Digital Revenue($)',
        'Digital Units Sold',
        'Digital Units',
      ].includes(titleContentTmp)
    ) {
      titleIconTmp = 'mscience';
    } else if (titleContentTmp === 'Viewers') {
      titleIconTmp = 'viewers';
    } else if (titleContentTmp === 'Physical Revenue($)') {
      titleIconTmp = 'npd';
    } else if (titleContentTmp === 'PHeat') {
      titleIconTmp = 'databrain';
    } else if (
      [
        'Sales of the Latest Week',
        'Revenue of the Latest Week',
        'Cumulative Sales of the Latest Week',
        'Cumulative Revenue of the Latest Week',
      ].includes(titleContentTmp)
    ) {
      titleIconTmp = 'famitsu';
    }
  } else if (type === 'depPlatform') {
    if (conditionPlatform === 'sensortower') {
      titleIconTmp = 'sensortower';
    } else {
      titleIconTmp = 'appnnie';
    }
  }
  return titleIconTmp;
};

export function emptyFormat(indicators = [], intl?: any) {
  indicators.forEach((item: any, index) => {
    item.titleContent = indicatorTitleContent(item.titleContent, '', '', intl);
    item.lineData = {};
    item.numArrowData = {};
    item.rankData = {};
    item.baseIndicators = {};
    item.lineDom = `line${index}`;
  });
  return indicators;
}

/**
 * @name: 当卡片指标接口返回null时，卡片默认显示数据处理
 * @param {*} type：页面类型，区别显示不同的数据
 * @return {*}
 */
export function emptyIndicators(type: any, intl?: any) {
  let indicators: any = [];
  if (type == 'pc' || type == 'PC') {
    indicators = indicatorPC;
  } else if (type == 'console' || type == 'Console') {
    indicators = indicatorConsole;
  }
  return emptyFormat(indicators || [], intl);
}

export const monthDic = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
} as any;

export const PLATFORM: { [key: string]: any } = {
  appnnie: 'data.ai',
  appannie: 'data.ai',
  hatchet: 'Hatchet',
  databrain: 'DataBrain',
  mscience: 'M Science',
  newzoo: 'Newzoo',
  sensortower: 'Sensor Tower',
  npdL: 'NPD',
};

const dealSepcialValue = (value: any, isRatioValueFormat = false) => {
  if (value === null) {
    return null;
  }
  if (value === 0 || value === '0') {
    return 0;
  }
  return financeFormat(value, isRatioValueFormat ? 4 : 2, false, 0);
  // return newMathFormat(value)
};

// 根据不同平台类型和时间段，返回适当的metric标识符
export const getMetricIdentifier = (
  originalMetric: string,
  timePeriod: string
): string => {
  if (originalMetric === 'databrain__lifetime_total_revenue') {
    return 'dbi_metric_lifetime_total_revenue';
  }
  if (originalMetric === 'databrain__lifetime_base_game_sales_units') {
    return 'dbi_metric_lifetime_base_game_sales_units';
  }

  const isRevenueMetric = originalMetric === 'Revenue';
  const timePeriodMappings = {
    lifetime: isRevenueMetric ? 'lifetimeRevenue' : 'lifetimeSales',
    'd1 after release': isRevenueMetric
      ? 'd1afterreleaseRevenue'
      : 'd1afterreleaseSales',
    'w1 after release': isRevenueMetric
      ? 'w1afterreleaseRevenue'
      : 'w1afterreleaseSales',
    'm1 after release': isRevenueMetric
      ? 'm1afterreleaseRevenue'
      : 'm1afterreleaseSales',
    'y1 after release': isRevenueMetric
      ? 'y1afterreleaseRevenue'
      : 'y1afterreleaseSales',
    'y1 after ea': isRevenueMetric ? 'y1aftereaRevenue' : 'y1aftereaSales',
    'last month': isRevenueMetric ? 'lastmonthRevenue' : 'lastmonthSales',
  };

  return (
    timePeriodMappings[timePeriod as keyof typeof timePeriodMappings] ||
    originalMetric
  );
};

/**
 * 前端计算平台百分比值
 *
 * @param {{ value: number }[]} platforms
 * @returns {*}
 */
const US_REVENUE_RELEASE_DAILY_TREND_LIMIT_MAP: Record<string, number> = {
  'd1 after release': 1,
  'w1 after release': 8,
  'm1 after release': 30,
};

const getUSRevenueReleaseDailyHistory = (history: any[] = [], steamDateType = '') => {
  const limit = US_REVENUE_RELEASE_DAILY_TREND_LIMIT_MAP[steamDateType];
  if (!limit || !Array.isArray(history)) return history || [];

  return history.slice(0, limit);
};

const isUSRevenueReleaseDailyTrend = (steamDateType = '') => {
  return Boolean(US_REVENUE_RELEASE_DAILY_TREND_LIMIT_MAP[steamDateType]);
};

const getPlatformsPercent = (platforms: { value: number }[]) => {
  if (!platforms?.length) return [];

  const totalValue = platforms.reduce((prev, curr) => {
    return prev + curr.value;
  }, 0);

  const calculatedPlatforms = platforms?.map((item) => {
    let percentInt;
    if (item.value === 0) {
      percentInt = 0;
    } else {
      percentInt = toFixed((item.value / totalValue) * 100, 1);
      // 最小值不足 0.1 的，固定展示 0.1
      if (percentInt < 0.1) {
        percentInt = 0.1;
      }
    }

    return {
      ...item,
      percent_int: percentInt,
      percent: `${percentInt}%`,
    };
  });

  // 避免加总后出现不足或超出 100% 的情况
  // 排序将最大占比放到最前面，方便处理
  calculatedPlatforms?.sort((a: any, b: any) => b.percent_int - a.percent_int);

  const totalPercent = calculatedPlatforms.reduce((prev, curr) => {
    return prev + curr.percent_int;
  }, 0);

  // 因为四舍五入，不足的小数舍去后相加可能不为 100%，将差值加到数据量最大的数据上
  const percentageDifference = 100 - totalPercent;

  // 避免小数处理精度丢失
  calculatedPlatforms[0].percent_int = toFixed(
    calculatedPlatforms[0].percent_int + percentageDifference,
    1,
  );
  calculatedPlatforms[0].percent = `${calculatedPlatforms[0].percent_int}%`;

  return calculatedPlatforms;
};

// 卡片传入的数据处理
export const getFormattedCardData = (
  data: any,
  entityType: string,
  conditionDate: string,
  conditionPlatform = 'appnnie',
  isNeedRateHover = false,
  isCN = false,
  steamDateType = '',
  intl?: any,
) => {
  if (!Array.isArray(data)) return [];
  if (data?.length === 0) return [];

  return data?.map((item: any, index: number) => {
    const {
      metric: metricTemp,
      value,
      rank,
      date,
      dod,
      value_dod,
      History,
      start_week,
      end_week,
      data_source,
      regions,
    } = item;
    const metric = getMetricIdentifier(
      metricTemp,
      steamDateType
    );
    const isReleaseDailyTrend = isUSRevenueReleaseDailyTrend(steamDateType);
    const lineHistory = getUSRevenueReleaseDailyHistory(History, steamDateType);
    // 日期选择-折线图x轴label显示规则
    const _dataType =
      steamDateType === 'last month' || isReleaseDailyTrend
        ? 'day'
        : conditionDate || 'month';

    const metricCompanyKey = `${data_source}_${metric}`;
    const titleKey = entityType === 'company' ? metricCompanyKey : metric;

    const _titleContent = indicatorTitleContent(
      titleKey,
      data_source,
      conditionPlatform,
      intl,
    );

    const getCompanySource = (str: any) => {
      const resStr = str.replace('company_', '');
      return resStr;
    };

    const dataSourceTemp =
      entityType === 'company' ? getCompanySource(data_source) : data_source;

    let depType = '';

    switch (entityType) {
      case 'mobile':
        depType = 'depPlatform';
        break;
      case 'company':
        depType = 'depDataSource';
        break;
      default:
        depType = 'depContentTitle';
        break;
    }

    const _titleIcon = indicatorsTitleIcon(
      _titleContent,
      depType,
      entityType == 'mobile' ? conditionPlatform : null,
      entityType == 'mobile' ? '' : metric,
      entityType == 'company' ? dataSourceTemp : '',
    );
    const _latestDate =
      _dataType === 'month'
        ? moment(date).format('YYYY-MM')
        : _dataType === 'week' && start_week
        ? `${moment(start_week).format('YYYY-MM-DD')}~${moment(end_week).format(
            'MM-DD',
          )}`
        : moment(date).format('YYYY-MM-DD');

    const {
      _indicatorContent,
      _indicatorSize,
      _indicatorColor,
      _isIndicatorArrow,
      _indicatprsArrowColor,
    } = indicatorValRankingFormat(dod);
    const {
      _rankContent,
      _rankColor,
      _rankSize,
      _isRankArrow,
      _rankArrowColor,
    } = rankRankingFormat(value_dod);
    const numArrowData = {
      numContent: _indicatorContent,
      numColor: _indicatorColor,
      numSize: _indicatorSize,
      arrow: _isIndicatorArrow,
      arrowColor: _indicatprsArrowColor,
    };

    const isRatioValueFormat =
      RATIOVALUEFORMATOVERVIEWCARDMETRIC?.includes(_titleContent);

    const baseIndicators = {
      indicatorsVal:
        item.metric === 'PHeat'
          ? value
          : dealSepcialValue(value, isRatioValueFormat),
      rankVal: rank,
      latestDate: _latestDate,
    };
    const rankData = {
      numContent: _rankContent,
      numColor: _rankColor,
      numSize: _rankSize,
      arrow: _isRankArrow,
      arrowColor: _rankArrowColor,
    };
    const lineData = {
      lineDom: `line${index}`,
      dataType: _dataType,
      // TODO 周时间显示为一个范围，空情况显示日
      weekDate:
        lineHistory?.map((d: any) =>
          d.start_date
            ? `${moment(d.start_date).format('YYYY-MM-DD')}~${moment(
                d.end_date,
              ).format('YYYY-MM-DD')}`
            : moment(d.date).format('YYYY-MM-DD'),
        ) || [],
      xAxisData: lineHistory?.map((d: any) => d.date) || [],
      seriesData: lineHistory?.map((d: any) => d.value) || [],
      predictData: lineHistory?.map((d: any) => d.b_predict) || [],
      xAxisLabelInterval: steamDateType === 'm1 after release' ? 5 : undefined,
    };

    // 对 platforms 数据占比进行重新计算，避免后端返回比值数据展示 0% 的情况
    const platformList = getPlatformsPercent(item.platforms);

    let cardObj = {
      metricUserGuide: metric,
      titleContent: _titleContent,
      titleIcon: _titleIcon,
      data_source: dataSourceTemp,
      baseIndicators,
      numArrowData,
      rankData,
      lineData,
      lineDom: `line${index}`,
      conditionDate,
      conditionPlatform,
      startDate: item.start_date,
      endDate: item.end_date,
      // platformList: item.platforms || [],
      platformList: platformList || [],
    } as any;

    const metricInfo = METRICS_INFOS?.[metricCompanyKey];
    const {
      nameTips: metricNameTips,
      nameTipsCN: metricNameTipsCN,
      dataSource,
    } = metricInfo ?? {};
    if (entityType === 'company') {
      cardObj = {
        ...cardObj,
        customBubbleContent: getMetricNameTips(
          metricNameTips as string,
          metricNameTipsCN as string,
          {
            isCN,
            dataSource,
            metricValue: value,
            regions,
          },
        ),
      } as any;
    }

    // 如果需要hover环比，显示环比对照数据
    if (isNeedRateHover) {
      if (Array.isArray(History) && History?.length > 0) {
        const endObj = History[History?.length - 1] || {};
        const endTwoObj = History[History?.length - 2] || {};
        cardObj = {
          ...cardObj,
          endRateStartTime: endObj?.start_date,
          endRateEndTime: endObj?.end_date,
          endRateDateTime: endObj?.date,
          endRateValue: endObj?.value,
          endTwoRateStartTime: endTwoObj?.start_date,
          endTwoRateEndTime: endTwoObj?.end_date,
          endTwoRateDateTime: endTwoObj?.date,
          endTwoRateValue: endTwoObj?.value,
        } as any;
      }
    }

    // 如果卡片有target_segment
    if (item?.target_segment) {
      cardObj = {
        ...cardObj,
        targetSegment: item?.target_segment,
      } as any;
    }

    return cardObj;
  });
};
